import script from "./Cancel.vue?vue&type=script&setup=true&lang=js"
export * from "./Cancel.vue?vue&type=script&setup=true&lang=js"

import "./Cancel.vue?vue&type=style&index=0&id=5820ff08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5820ff08"]])

export default __exports__